import React from "react";

export default function MissedCallIcon() {
	return (
		<svg width="27" height="23" viewBox="0 0 27 23" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path d="M18.4743 13.5H8.52575C4.51472 13.5 1.23163 17.3346 1.23163 22.0368H6.95222C7.48612 21.99 7.88378 21.5236 7.8456 20.989V19.6875C7.8456 18.8346 8.44119 18.136 9.16545 18.136H17.8346C18.5699 18.136 19.1544 18.8346 19.1544 19.6875V20.989C19.1162 21.5236 19.5139 21.99 20.0478 22.0368H25.7684C25.7684 17.3346 22.4853 13.5 18.4743 13.5Z" fill="white" stroke="#3858DC" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
			<path d="M20.9412 2.38235L13.5 9.82353L5.25735 1.58088" stroke="#3858DC" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
			<path d="M4.89706 5L4.8125 1.19118L8.73529 1.44485" stroke="#3858DC" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
		</svg>
	);
}
